var map = {
	"./cover.jpg": 1913,
	"./image1.jpg": 9578,
	"./image2.jpg": 2181,
	"./image3.jpg": 8664,
	"./image4.jpg": 8667,
	"./image5.jpg": 7182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3544;